module.exports = __webpack_public_path__ + "static/audio-editor-slide-80abc917048541faaf03a5490dc81bca.jpg";